/* ---------------------------------------------------------------------------
   Zet de glans op de grote bestelknop ("In winkelwagen") en op de afrekenknop
   van de winkelwagenpagina.

   Twee triggers:

   1. In beeld komen — een IntersectionObserver zet de klasse .is-shine op de
      knop zodra die voor een derde zichtbaar is, en haalt hem er weer af zodra
      de knop uit beeld verdwijnt. Daardoor begint de CSS-animatie bij elke
      terugkeer opnieuw. Bij het openen van de pagina meldt de observer meteen
      of de knop al in beeld staat, dus daar is geen aparte start voor nodig.

   2. Scrollen — de afrekenknop veegt bovendien opnieuw bij elke scrollbeweging,
      zolang hij in beeld staat. Een nieuwe veeg begint pas als de vorige klaar
      is (CYCLUS), anders zou de streep bij elk scrollframe opnieuw beginnen en
      halverwege blijven hangen. Stop je met scrollen, dan stopt de herhaling
      vanzelf na de lopende veeg.

   De veeg in de vaste onderbalk (.ds-mbar__cta) zit puur in de CSS: die loopt
   door zolang de balk zichtbaar is.
--------------------------------------------------------------------------- */
(function () {
  var KNOPPEN = '.ds-buy__atc:not(.ds-buy__atc--notify), .ds-cart__checkout';
  var BIJ_SCROLL = '.ds-cart__checkout';
  /* Gelijk aan de animatie in ds-atc-shine.css: 0,35s vertraging + 1,15s duur. */
  var CYCLUS = 1500;

  var knoppen = [].slice.call(document.querySelectorAll(KNOPPEN));
  if (!knoppen.length) return;

  /* Zonder IntersectionObserver (heel oude browser) gewoon één keer glanzen,
     zodat de knop er daar niet dood bij staat. */
  if (typeof IntersectionObserver === 'undefined') {
    for (var i = 0; i < knoppen.length; i++) knoppen[i].classList.add('is-shine');
    return;
  }

  function glans(el) {
    el.classList.remove('is-shine');
    /* Even de layout opvragen: dat dwingt de browser de animatie echt af te
       breken, anders ziet hij het weghalen en terugzetten als één geheel en
       begint de veeg niet opnieuw. */
    void el.offsetWidth;
    el.classList.add('is-shine');
    el.dsGlansTijd = Date.now();
  }

  var kijker = new IntersectionObserver(function (waarnemingen) {
    for (var i = 0; i < waarnemingen.length; i++) {
      var w = waarnemingen[i];
      w.target.dsInBeeld = w.isIntersecting;
      if (w.isIntersecting) glans(w.target);
      else w.target.classList.remove('is-shine');
    }
  }, { threshold: 0.35 });

  var scrollKnoppen = [];
  for (var j = 0; j < knoppen.length; j++) {
    kijker.observe(knoppen[j]);
    if (knoppen[j].matches(BIJ_SCROLL)) scrollKnoppen.push(knoppen[j]);
  }

  if (!scrollKnoppen.length) return;

  /* Eén keer per frame kijken, niet bij elke losse scrollmelding. */
  var gepland = false;
  window.addEventListener('scroll', function () {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(function () {
      gepland = false;
      var nu = Date.now();
      for (var k = 0; k < scrollKnoppen.length; k++) {
        var el = scrollKnoppen[k];
        if (el.dsInBeeld && nu - (el.dsGlansTijd || 0) >= CYCLUS) glans(el);
      }
    });
  }, { passive: true });
})();
